<span class="inline-flex flex-wrap items-center gap-x-1.5 whitespace-nowrap">
  {{ event.name }}
  @if (coerced) {
    <!-- The one verdict that contradicts the form: a Kassen-Event was asked for, a virtual one came back.
         Amber, because it is a change the reader has to notice — not a refusal, and not business as usual. -->
    <span class="inline-flex items-center rounded-full bg-amber-50 px-2 py-0.5 align-top text-xs font-semibold text-amber-700">
      Virtuell (umgewandelt)
    </span>
  } @else if (virtual) {
    <span class="inline-flex items-center rounded-full bg-indigo-50 px-2 py-0.5 align-top text-xs font-semibold text-indigo-700">
      Virtuell
    </span>
  }
</span>
